import { useContext, useEffect, useRef, useState } from "react";
import { Col, Row, Tab, Tabs } from "react-bootstrap";
import { SalaryPaymentsDto } from "../../../../dtos/documents/SalaryPayments/SalaryPaymentsDto";
import { FormProvider, Resolver, useForm } from "react-hook-form";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NewDocumentModalViewContext } from "../../../Shared/NewDocumentModalView";
import { DocumentModalViewHeader } from "../../../Shared/DocumentModalViewHeader";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFTextAreaInput } from "../../../Shared/NewForms/NFTextAreaInput";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { NFTabs } from "../../../Shared/NewForms/NFTabs";
import { NFTab } from "../../../Shared/NewForms/NFTab";
import { NFTabContainer } from "../../../Shared/NewForms/NFTabContainer";
import { NFLookupEmployee } from "../../../Shared/NewForms/NFLookupEmployee";
import handleFormSubmit, { DocumentSaveActionType } from "../../../../helpers/DocumentHelper";
import { AppEntities } from "../../../../config/entities";
import { importFromExcel, saveObjectToExcel } from "../../../../helpers/SaveObjectToExcel";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupCompany } from "../../../Shared/NewForms/NFLookupCompany";
import { NFLookupDivision } from "../../../Shared/NewForms/NFLookupDivision";
import { SalaryPaymentsModel } from "../../../../models/Documents/SalaryPayments/SalaryPaymentsModel";
import { NFLookupAccrual } from "../../../Shared/NewForms/NFLookupAccrual";
import { NFLookupSalaryPayments } from "../../../Shared/NewForms/NFLookupSalaryPayments";
import SalaryPaymentsDetailSkeleton from "./SalaryPaymentsDetailSkeleton";
import { SalaryPaymentsDetailFooter } from "./SalaryPaymentsDetailFooter";
import DocumentDetailViewToolbar from "../../../Shared/DetailViews/DocumentDetailViewToolbar";
import DetailViewPostButton from "../../../Shared/DetailViews/DetailViewPostButton";
import DetailViewSaveButton from "../../../Shared/DetailViews/DetailViewSaveButton";
import DetailViewCancelButton from "../../../Shared/DetailViewCancelButton";
import DetailViewToolbarMoreActions from "../../../Shared/DetailViews/DetailViewToolbarMoreActions";
interface IProps {
  model: SalaryPaymentsDto | null;
  modelUpdatedEvent: (newModel: SalaryPaymentsDto) => void;
}

export const SalaryPaymentsDetail = ({ model, modelUpdatedEvent }: IProps) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
    formState,
    getValues,
    watch,
    control,
    trigger,
    ...methods
  } = useForm<SalaryPaymentsModel>();

  const modalViewContext = useContext(NewDocumentModalViewContext);
  const { postHandler, saveHandler, closeHandler, cancelHandler } = modalViewContext;
  const [tabIndex, setTabIndex] = useState(0);
  const [fileName, setFileName] = useState("Salary Payments");

  const watchProducts = watch("salaryPaymentPayments");

  useEffect(() => {
    console.log("model - ", model);
    register("salaryPaymentPayments");
    if (model) {
      setValue("id", model.id);
      setValue("documentNumber", model.documentNumber);
      setValue("documentDate", model.documentDate);
      setValue("comment", model.comment);
      setValue("salaryPaymentPayments", model.salaryPaymentPayments);
    }
  }, [model]);

  const handleFormSubmitLocal = async (action: DocumentSaveActionType, data: SalaryPaymentsModel) => {
    await handleFormSubmit(action, data, model, saveHandler, postHandler);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newPrice * newProducts[index].quantity;
    // setValue(`salaryAccrualEmployees.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newProducts = [...watchProducts];
    console.log("newProducts", newProducts);
    // @ts-ignore
    const newAmount = newQuantity * newProducts[index].price;
    // setValue(`salaryAccrualEmployees.${index}.amount`, newAmount);
    console.log(newAmount);
  };

  if (!model) {
    return (
      <>
        <SalaryPaymentsDetailSkeleton />
      </>
    );
  }
  const handleTabChange = (index: number) => {
    setTabIndex(index);
  };
  const exportToExcel = () => {
    const data = {
      ...model
    };
    const documentInfo = {
      title: AppEntities.SalaryPayments.title,
      number: model.documentNumber,
      date: model.documentDate
    };
    saveObjectToExcel(data, documentInfo);
  };

  const handleUploadFile = (file: File) => {
    importFromExcel(file, (data: any) => {
      reset(data);
    });
  };

  return (
    <FormProvider
      getValues={getValues}
      setValue={setValue}
      register={register}
      control={control}
      trigger={trigger}
      reset={reset}
      watch={watch}
      handleSubmit={handleSubmit}
      formState={formState}
      {...methods}
    >
      <NFTabs
        onTabChange={(newIndex) => {
          setTabIndex(newIndex);
        }}
      >
        <NFTab title={"Main"} />
        <NFTab title={"Salary Payments"} />
      </NFTabs>

      <div className={"modal-container-height"}>
        <DocumentDetailViewToolbar>
          <DetailViewPostButton onPost={handleSubmit((data) => handleFormSubmitLocal("post", data))} />
          <DetailViewSaveButton onSave={handleSubmit((data) => handleFormSubmitLocal("save", data))} />
          <DetailViewCancelButton onCancel={cancelHandler} />
          <DetailViewToolbarMoreActions handleUploadFile={handleUploadFile} exportToExcel={exportToExcel} fileName={fileName} setFileName={setFileName} />
        </DocumentDetailViewToolbar>

        <NFTabContainer index={0} currentIndex={tabIndex}>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Document #"} disabled fieldName={"documentNumber"} />
            </Col>
            <Col sm={3}>
              <NFDateInput title={"Document Date"} fieldName={"documentDate"} required={true} />
            </Col>
            <Col sm={3}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} required={true} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupCompany title={"Company"} fieldName={"companyId"} />
            </Col>
            <Col sm={6}>
              <NFLookupDivision title={"Division"} fieldName={"divisionId"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFLookupAccount title="paymentAccountId" fieldName="paymentAccountId" />
            </Col>
            <Col sm={3}>
              <NFLookupAccrual title="paymentArticleId" fieldName="paymentArticleId" />
            </Col>
            <Col sm={3}>
              <NFDateInput title="month" fieldName="month" />
            </Col>
          </Row>
        </NFTabContainer>
        <NFTabContainer index={1} currentIndex={tabIndex}>
          <NFormTable fieldArray={"salaryPaymentPayments"}>
            <NFLookupSalaryPayments fieldName={"salaryPaymentId"} title={"Salary Payment"} width={200} />
            <NFLookupEmployee fieldName={"employeeId"} title={"employeeId"} width={200} />
            <NFIntInput fieldName={"personalIncomeTax"} title={"Personal income tax"} width={100} />
            <NFIntInput fieldName={"pensionCompanyAmount"} title={"Pension Company Amount"} width={100} />
            <NFIntInput fieldName={"pensionEmployeeAmount"} title={"Pension Employee Amount"} width={100} />
            <NFIntInput fieldName={"incomeTaxAmount"} title={"Income Tax Amount"} width={100} />

            <NFIntInput fieldName={"debtGrossAmount"} title={"Debt Gross Amount"} width={100} />
            <NFIntInput fieldName={"amountNet"} title={"amountNet"} width={100} />
            <NFTextInput fieldName={"description"} title={"description"} />
          </NFormTable>
        </NFTabContainer>
        <NFTabContainer index={2} currentIndex={tabIndex}>
          <Row>
            <Col sm={12}>
              <NFTextAreaInput fieldName={"comment"} title={"Comment"} required={false} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={"Created User"} fieldName={"createdUser"} disabled={true} />
            </Col>
            <Col sm={6}>
              <NFDateInput title={"Created Date"} fieldName={"createdDate"} disabled={true} />
            </Col>
          </Row>
        </NFTabContainer>
      </div>
      <SalaryPaymentsDetailFooter />
    </FormProvider>
  );
};
